import comp from "./ProductUpdatesModal";
export default comp;
